var init = false; // ΔVΔVΔ: delete token on page load

const LocalStorageService = (function () {
    var _service;
    function _getService() {
        if (!_service) {
            _service = this;
            return _service;
        }
        return _service;
    }
    function _setToken(tokenObj) {
        localStorage.setItem('access_token', tokenObj.access_token);
        localStorage.setItem('refresh_token', tokenObj.refresh_token);
        localStorage.setItem('token_expires', tokenObj.expires);
    }
    function _getAccessToken() {
        let token = localStorage.getItem('access_token');
        const expires = localStorage.getItem('token_expires');
        if (expires == 'undefined' || new Date().getTime() + 20 > expires || !expires) {
            _clearToken();
            return false;
        }
        return token;
    }
    function _getRefreshToken() {
        return localStorage.getItem('refresh_token');
    }
    function _clearToken() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('token_expires');
    }
    if (!init) {
        delete window.localStorage.access_token;
        init = true;
    }
    return {
        getService: _getService,
        setToken: _setToken,
        getAccessToken: _getAccessToken,
        getRefreshToken: _getRefreshToken,
        clearToken: _clearToken
    };
})();
export default LocalStorageService;
